import { millisecondsToSeconds } from 'date-fns';
import { action, computed, makeObservable, observable } from 'mobx';

import { hasValue } from 'src/shared/utils/common';
import { equalsDeep } from 'src/shared/utils/equals-deep';

import type { TPreparationStatus, TRawRSE } from '../types';

export class RigSiteEvent {
  initialValues: TRawRSE;
  readonly id: string | 'blank';

  @observable values: TRawRSE;

  constructor(initialRSE: TRawRSE) {
    this.initialValues = initialRSE;
    this.values = initialRSE;
    this.id = initialRSE.rseUuid ?? 'blank';

    makeObservable(this);
  }

  @computed
  get RSEReadiness(): { padReady: TPreparationStatus } {
    const padReady: TPreparationStatus = (() => {
      if (!hasValue(this.values.padReadyDate)) {
        return 'notReady';
      }

      const currentUnixTime = millisecondsToSeconds(Date.now());

      if (currentUnixTime >= this.values.padReadyDate) {
        return 'ready';
      }

      return 'inProcess';
    })();

    return {
      padReady,
    };
  }

  @computed
  get hasChanges(): boolean {
    return equalsDeep(this.initialValues, this.values);
  }

  @action.bound
  updateValues(values: Partial<TRawRSE>): void {
    this.values = { ...this.values, ...values };
  }

  @action.bound
  restoreInitialValues(): void {
    this.values = { ...this.initialValues };
  }

  @action.bound
  updateInitialValues(values: Partial<TRawRSE>): void {
    this.initialValues = { ...this.initialValues, ...values };
    this.values = { ...this.values, ...values };
  }

  copySelf = (): RigSiteEvent => {
    return new RigSiteEvent(this.initialValues);
  };
}
